export enum SearchType {
  BASIC = "BASIC",
  ADVANCED = "ADVANCED",
}
